import { render, staticRenderFns } from "./DropdownShifter.vue?vue&type=template&id=4577a0e1&scoped=true&lang=pug&"
import script from "./DropdownShifter.vue?vue&type=script&lang=js&"
export * from "./DropdownShifter.vue?vue&type=script&lang=js&"
import style0 from "./DropdownShifter.vue?vue&type=style&index=0&id=4577a0e1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4577a0e1",
  null
  
)

export default component.exports